module.exports = __webpack_public_path__ + "media/images/HandsHoldingHearts-49999066.svg";